import { ExampleConfig } from '../types';
import { decodeJwtPayload, jwtToken } from './token';

const ENV_SERVICE_URLS: Record<string, string> = {
  production: import.meta.env.VITE_WEB_SERVICE_URL_PRODUCTION,
  uat: import.meta.env.VITE_WEB_SERVICE_URL_UAT,
  staging: import.meta.env.VITE_WEB_SERVICE_URL_STAGING,
  sandbox: import.meta.env.VITE_WEB_SERVICE_URL_SANDBOX,
};

export const getWebServiceUrl = (): string => {
  const env = new URL(window.location.href).searchParams.get('env');
  return (env && ENV_SERVICE_URLS[env]) || import.meta.env.VITE_WEB_SERVICE_URL;
};

const getAuthorInfo = (payload: any) => {
  const source = payload.dev_info ?? payload.user_info;

  if (!source) {
    return {
      author_name: undefined,
      author_email: undefined,
    };
  }

  const firstName = source.first_name ?? '';
  const lastName = source.last_name ?? '';

  return {
    author_name: `${firstName} ${lastName}`.trim() ?? 'null',
    author_email: source.email ?? 'null',
  };
};

const currentAccountInfo = decodeJwtPayload();

export const getConfigFromUrl = (): Partial<ExampleConfig> => {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const config: Partial<ExampleConfig> = {};

  const projectPath = params.get('projectPath') || params.get('repo');
  if (projectPath) config.projectPath = projectPath;

  config.gitlabUrl = undefined;
  config.gitRef = params.get('gitRef') || params.get('ref') || 'main';
  config.funnel_id = params.get('funnel_id') || '';
  config.author_name = getAuthorInfo(currentAccountInfo).author_name;
  config.author_email = getAuthorInfo(currentAccountInfo).author_email;
  config.account_id = currentAccountInfo?.account_info?.id?.toString();
  config.jwt_token = jwtToken();
  config.staging_mode = params.get('staging_mode') ?? undefined;

  config.webServiceUrl = getWebServiceUrl();
  // Separate base for the funnel deploy/preview/all-tokens routes; when
  // unset, the extension falls back to webServiceUrl.
  config.funnel_api_url = import.meta.env.VITE_FUNNEL_API_URL || undefined;
  console.log(config.webServiceUrl);

  console.log('------------------', config);
  return config;
};
